const EmptyState = ({ icon: Icon, message, action, actionLabel }) => {
    return (
        <div className="text-center py-8">
            {Icon && <Icon className="text-4xl text-gray-300 mx-auto mb-3" />}
            <p className="text-gray-600 mb-4">{message}</p>
            {action && actionLabel && (
                <button
                    onClick={action}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
                >
                    {actionLabel}
                </button>
            )}
        </div>
    );
};

export default EmptyState;

